module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.checkLoginStatus()) ? _c('topbar', {
    attrs: {
      "user": _vm.user,
      "toggle_aside": _vm.toggle_aside
    },
    model: {
      value: (_vm.toggle_aside),
      callback: function($$v) {
        _vm.toggle_aside = $$v
      },
      expression: "toggle_aside"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "user": _vm.user,
      "toggle_aside": !_vm.toggle_aside
    },
    model: {
      value: (_vm.toggle_aside),
      callback: function($$v) {
        _vm.toggle_aside = $$v
      },
      expression: "toggle_aside"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-020c7b54","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 660
// module chunks = 4